import dataService from "@/services/data.service"
import { utils } from "../helpers"
import store from "@/store"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { setI18nLanguage } from "@/store/constants/messages.js"
// this should contain only the UI variables that we
// want to keep in sync with the server // snake cased
export const initialRemoteUIVariables = {
  is_sidebar_collapsed: false,
  side_menu_open: true,
  hide_onboarding_popup: false,
  current_path: null,
  main_menu_items: [],
  actions_menu_items: [],
  pages: [],
  interaction_tags: [],
  side_menu_open_calc: false,
  onboarding_team_selected: null,
  selected_agent_id: null
}

export const initialLocalUIVariables = {
  is_search_palette_open: false,
  layout_edit_mode_active: false,
  palette_search_selected_object_types: [],
  showLoading: false,
  ajaxCallIsOn: false,
  updated_records_queue: [],
  modal_stack: [],
  loadingText: "",
  sideBarSearchText: "",
  integrationSelectedService: "",
  currentSelectedLeftMenuTab: "Home",
  notificationInfo: null,
  showNotificationInfo: false,
  pages_bread_crumbs: {},
  adminBreadcrumb: [],
  admin_integrations_breadcrumb: [],
  currentWorkspace: null,
  workspace_user_access_scope: null,
  // Current company profile opened
  currentCompany: null,
  last_portfolio_req_obj: null,
  onboarding_team_selected: null,

  // Current page
  /*
  prospecting
  phases
  forecast
  command_center
  company_profile */
  currentPage: "portfolio",
  // Current Tab
  currentTab: null,
  portfolio: {
    ui_options: {
      language: "en",
      theme: {
        name: "Default",
        bg_color: "#07455d",
        header_color: "#FFFFFF",
        selected_item_color: "#579FBB",
        button_color: "#0D8ABA"
      }
    }
  },
  darkMode: false,
  cursor_positions: { x: null, y: null, closest_side: null }
}

const initialVariables = {
  ...initialLocalUIVariables,
  ...initialRemoteUIVariables
}

const initialState = { ...initialVariables }

export const ui = {
  namespaced: true,
  state: initialState,
  actions: {
    setCursorPosition({ commit }, { x, y, closest_side }) {
      commit("setCursorPositions", { x, y, closest_side })
    },
    // Remote UI variables
    setUIValue({ commit, rootState, state }, values) {
      // if the keys and values in values are the same
      // the call to the backend
      //@moussa this breaks the menu
      // if (utils.isEqual(values, rootState.portfolio.ui_options, true, null, Object.keys(values))) {
      //   console.debug("No changes in UI options. Skipping BE call.")
      //   return
      // }
      // if user is auth
      if (!rootState.auth.user) {
        return
      }
      const prevented_BE_call_actions = ["layout_edit_mode_active"]
      let perform_BE_call = true
      let ui = rootState.portfolio.ui_options

      if (!ui) {
        ui = {}
      }
      Object.keys(values).forEach((value) => {
        if (prevented_BE_call_actions.includes(value)) {
          perform_BE_call = false
        }
        ui[value] = values[value]
      })

      // update root ui_options
      commit("setUIOptions", ui, { root: true })

      commit("setUIValue", values)

      if (perform_BE_call) {
        return utils.debounce(() => {
          if (!utils.isEqual(values, state.last_portfolio_req_obj)) {
            dataService
              .updatePortfolio({ ui_options: ui })
              .then((response) => {
                commit("setLastPortfolioReqObj", ui) // Update last_portfolio_req_obj on success
                return Promise.resolve(response?.data)
              })
              .catch((error) => {
                return Promise.reject(error)
              })
          }
        }, 2000)
      }
    },

    updateLayouts({ commit, rootState }, { module, layout }) {
      const portfolio = rootState.portfolio
      const pages_layouts_clone = portfolio.pages_layout
      pages_layouts_clone[module] = layout

      return utils.debounce(() => {
        dataService
          .updatePortfolio({ pages_layout: pages_layouts_clone })
          .then(
            (response) => {
              commit("setPortfolio", portfolio, { root: true })
              return Promise.resolve(response.data)
            },
            (error) => {
              return Promise.reject(error)
            }
          )
          .catch((error) => {
            return Promise.reject(error)
          })
      }, 1000)
    },

    setUIValueSync({ commit, rootState }, values) {
      let ui = rootState.portfolio.ui_options
      Object.keys(values).forEach((value) => {
        ui[value] = values[value]
      })

      // update root ui_options
      commit("setUIOptions", ui, { root: true })
      commit("setUIValue", values)
      commit("setLastPortfolioReqObj", values)

      return dataService
        .updatePortfolio({ ui_options: ui })
        .then(
          (response) => {
            return Promise.resolve(response.data)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    getPortfolio: {
      root: true,

      // eslint-disable-next-line no-empty-pattern
      async handler({ commit, rootState, dispatch }) {
        return await dataService.getPortfolio().then(
          (response) => {
            let portfolio = { ...rootState.portfolio, ...response.data }
            commit("setPortfolio", portfolio, { root: true })
            commit("setUIOptions", response.data.ui_options, { root: true })

            commit("setObjectTypes", response.data.object_types, { root: true })
            dispatch("realtime/joinLayoutStreams", portfolio, { root: true })
            return Promise.resolve(response.data)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    },
    syncSheetUpdated: {
      // Don't change!. Predefined actions called by the server
      root: true,

      // eslint-disable-next-line no-empty-pattern
      async handler() {
        this.$emitter.emit(ALL_EMITTERS.SYNC_SHEET_UPDATED)
      }
    },
    refetchPortfolio: {
      // Don't change!. Predefined actions called by the server
      root: true,

      // eslint-disable-next-line no-empty-pattern
      async handler({ commit, dispatch, rootState }, data) {
        if (data.user == rootState.auth.user.id || !data.user) {
          return await dataService.getPortfolio().then(
            (response) => {
              let portfolio = { ...rootState.portfolio, ...response.data }
              commit("setPortfolio", portfolio, { root: true })
              commit("setUIOptions", response.data.ui_options, { root: true })
              if (response?.data?.object_types) {
                commit("setObjectTypes", response.data.object_types, { root: true })
              }
              dispatch("realtime/joinLayoutStreams", portfolio, { root: true })
              return Promise.resolve(response.data)
            },
            (error) => {
              return Promise.reject(error)
            }
          )
        }
      }
    },
    updateLayout: {
      // Don't change!. Predefined actions called by the server
      root: true,

      // eslint-disable-next-line no-empty-pattern
      async handler({ commit, rootState }, data) {
        let new_layout = data?.layout
        let changed_by = data?.changed_by
        if (!new_layout) {
          return
        }
        if (rootState.auth.user.id !== changed_by) {
          if (new_layout.shared_with.map((x) => x.id).includes(rootState.auth.user.id) || new_layout.owner == rootState.auth.user.id) {
            let portfolio = rootState.portfolio
            let pages_layout = null
            let page_reference = new_layout.page
            if (new_layout.owner == rootState.auth.user.id) {
              pages_layout = portfolio.pages_layout[page_reference]
            } else {
              pages_layout = portfolio.shared_layouts
            }

            let index = pages_layout.findIndex((layout) => layout.id == new_layout.id)
            if (index == -1) {
              pages_layout.push(new_layout)
            } else {
              // replace
              pages_layout.splice(index, 1, new_layout)
            }

            if (new_layout.owner == rootState.auth.user.id) {
              portfolio.pages_layout[page_reference] = pages_layout
            } else {
              portfolio["shared_layouts"] = pages_layout
            }
            commit("setPortfolio", portfolio, { root: true })
            this.$emitter.emit(ALL_EMITTERS.LAYOUT_UPDATED, { layout: new_layout, silent: true })
            this.$emitter.emit(ALL_EMITTERS.LAYOUT_UPDATED_IN_ADD_COMPONENTES_MODAL, { layout: new_layout, silent: true })
          }
        }
      }
    },

    setLayout: {
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        return dataService
          .updateLayout(data)
          .then(
            (response) => {
              return Promise.resolve(response.data)
            },
            (error) => {
              return Promise.reject(error)
            }
          )
          .catch((error) => {
            if (error.response?.data?.code == "OUTDATED_LAYOUT") {
              if (error.response?.data?.data?.layout) {
                this.$emitter.emit(ALL_EMITTERS.LAYOUT_UPDATED, { layout: error.response?.data.data.layout, silent: true })
              }
            }
          })
      }
    },

    setPortfolio: {
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({ commit, rootState }, data) {
        let portfolio = { ...rootState.portfolio, ...data }
        commit("setPortfolio", portfolio, { root: true })
        commit("setUIOptions", portfolio.ui_options, { root: true })

        commit("setLastPortfolioReqObj", data)

        return dataService
          .updatePortfolio(data)
          .then(
            (response) => {
              if (response?.data?.object_types) {
                commit("setObjectTypes", response.data.object_types, { root: true })
              }

              return Promise.resolve(response.data)
            },
            (error) => {
              return Promise.reject(error)
            }
          )
          .catch((error) => {
            return Promise.reject(error)
          })
      }
    },
    switchLanguage({ dispatch }, lang = "en") {
      setI18nLanguage(window.i18n, lang)
      dispatch("setUIValue", { language: lang })
    },
    toggleTheme({ commit }) {
      commit("doToggleTheme")
    },

    setEditModeActive({ commit }, value) {
      commit("setEditModeActive", value)
    },
    setSideBarSearchText({ commit }, value) {
      commit("setSideBarSearchText", value)
    },

    setIntegrationSelectedService({ commit }, name) {
      commit("setIntegrationSelectedService", name)
    },
    setCurrentSelectedTab({ commit }, name) {
      commit("setCurrentSelectedTab", name)
    },

    toggleAjaxCallIsOn({ commit }, cpt) {
      commit("setAjaxCallIsOn", cpt > 0)
    },
    showLoading({ commit }, desc) {
      commit("setLoading", { state: true, text: desc })
    },
    hideLoading({ commit }) {
      commit("setLoading", { state: false, text: "" })
    },

    showNotification({ commit }, info) {
      commit("showNotification", info)
      if (info.closeIn) {
        setTimeout(() => {
          setImmediate(() => {
            commit("hideNotification")
          })
        }, info.closeIn)
      }
    },
    hideNotification({ commit }) {
      commit("hideNotification")
    },

    setCurrentAdminBreadcrumb({ commit }, bcrumb) {
      commit("setCurrentAdminBreadcrumb", bcrumb)
    },
    setCurrentAdminIntegrationsBreadcrumb({ commit }, bcrumb) {
      commit("setCurrentAdminIntegrationsBreadcrumb", bcrumb)
    },

    setCurrentWorkspace({ commit }, workspace) {
      commit("setCurrentWorkspace", workspace)
    },

    setCurrentCompany({ commit, rootState, dispatch }, company) {
      // add to last viewed
      if (company) {
        if (company.id != rootState.ui.currentCompany?.id) {
          let last_viewed_records = rootState.ui_options?.last_viewed_records ? rootState.ui_options.last_viewed_records : []
          last_viewed_records = last_viewed_records.filter((e) => e.id != company.id)
          last_viewed_records.unshift({
            id: company.id,
            object_type: company.type,
            name: utils.Record(company).name,
            url: utils.Record(company).url
          })
          // no more then 10
          last_viewed_records = last_viewed_records.slice(0, 10)
          dispatch("setUIValue", { last_viewed_records: last_viewed_records })
        }
      }
      commit("setCurrentCompany", company)
    },
    setCurrentCompanyBreadcrumb({ commit }, bcrumb) {
      commit("setCurrentCompanyBreadcrumb", bcrumb)
    },

    setCurrentPage({ commit }, page) {
      commit("setCurrentPage", page)
    },
    setCurrentTab({ commit }, page) {
      commit("setCurrentTab", page)
    }
  },
  mutations: {
    addModalToStack(state, modal_id) {
      if (modal_id) {
        if (!state.modal_stack.includes(modal_id)) {
          state.modal_stack.push(modal_id)
        }
      }
    },
    removeModalFromStack(state, modal_id) {
      state.modal_stack = state.modal_stack.filter((x) => x != modal_id)
    },

    setCursorPositions(state, { x, y, closest_side }) {
      state.cursor_positions = { x, y, closest_side }
    },
    stateReset(state) {
      Object.assign(state, initialState)
    },
    toggleSearchPalette(state, status) {
      state.is_search_palette_open = status
    },
    setCurrentPage(state, page) {
      state.currentPage = page
    },
    setCurrentTab(state, tab) {
      state.currentTab = tab
    },

    setPageBreadCrumb(state, { page, breadc }) {
      state.pages_bread_crumbs[page] = breadc
    },

    // We used this way because the UI vars that are related to the server are known
    // and well defined
    setUIValue(state, data) {
      Object.keys(data).forEach((value) => {
        state[value] = data[value]
      })
    },
    setUpdatedRecords(state, value) {
      state.updated_records_queue = value
    },
    addToUpdatedObjectsQueue(state, name) {
      state.updated_records_queue.push(name)
    },
    removeFromUpdatedObjectsQueue(state, name) {
      state.updated_records_queue = state.updated_records_queue.filter((x) => x == name)
    },
    setSideBarSearchText(state, value) {
      state.sideBarSearchText = value
    },

    setEditModeActive(state, value) {
      state.layout_edit_mode_active = value
    },
    setIntegrationSelectedService(state, name) {
      state.integrationSelectedService = name
    },
    setLastPortfolioReqObj(state, data) {
      state.last_portfolio_req_obj = utils.clone(data)
    },
    setCurrentSelectedTab(state, tab) {
      state.currentSelectedLeftMenuTab = tab
    },
    setAjaxCallIsOn(state, status) {
      state.ajaxCallIsOn = status
    },
    setLoading(state, status) {
      state.showLoading = status.state
      state.loadingText = status.text
    },
    showNotification(state, info) {
      state.notificationInfo = info
      state.showNotificationInfo = true
    },
    hideNotification(state) {
      state.showNotificationInfo = false
    },
    setCurrentAdminBreadcrumb(state, value) {
      state.adminBreadcrumb = value
    },
    setCurrentAdminIntegrationsBreadcrumb(state, value) {
      state.admin_integrations_breadcrumb = value
    },
    setCurrentCompany(state, value) {
      state.currentCompany = value
    },
    setCurrentWorkspace(state, value) {
      state.currentWorkspace = value
      if (value) {
        const collaborator = [...value.team_members, ...value.contacts].find((c) => c.id == store.state.auth.user.id)
        state.workspace_user_access_scope = collaborator?.workspace_access?.access_scope
      }
    },
    setCurrentCompanyBreadcrumb(state, value) {
      state.companyBreadcrumb = value
    },
    doToggleTheme(state) {
      state.darkMode = !state.darkMode
      this.$emitter.emit(ALL_EMITTERS.DARK_MODE_CHANGED)
    }
  }
}
